import { render, staticRenderFns } from "./OverallMetrics.vue?vue&type=template&id=113bb488&scoped=true&"
import script from "./OverallMetrics.vue?vue&type=script&lang=js&"
export * from "./OverallMetrics.vue?vue&type=script&lang=js&"
import style0 from "./OverallMetrics.vue?vue&type=style&index=0&id=113bb488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113bb488",
  null
  
)

export default component.exports